import React from 'react';
import classNames from 'classnames';
import Icon from 'atomic/icon';

import './alert.scss';

interface NoResultProps {
    color: 'info' | 'warning';
    children: React.ReactNode;
}

const Alert: React.FC<NoResultProps> = ({ color, children }) => {
    return (
        <div
            className={classNames({
                alert: true,
                [`alert--${color}`]: true
            })}
        >
            <Icon name={color === 'warning' ? 'alert-triangle' : 'info'} />
            <div className="alert__text">
                {children}
            </div>
        </div>
    );
};

export default Alert;
